import { authRole, authEntities } from './helpers/conf';

const dev = process.env.NODE_ENV === 'development';

// const devDomain = '192.168.1.10'; //que lea el process.env.REACT_APP_BASE_UR
// const prodDomain = 'gps-administration-api.mavimovil.com';

const domain = process.env.REACT_APP_BASE_URL;

// abajo donde esta el http cambiar por devDomain porque ahi va a estar toda la variable de entorno 

// const conf = {
//     api: !dev ? `http://${devDomain}:37001/api` : `https://${prodDomain}/api`,
//     cdnLogin: !dev ? 'http://localhost:3001/#/signin' : 'https://gps-operation.mavimovil.com/#/signin',
//     cdnWebSocketTransimissionValidator: !dev ? `wss://${devDomain}:39002` : `wss://gps-validations-api.mavimovil.com:39002`,
//     cdnHistoricalTransimissionValidator: !dev ? `http://${devDomain}:39003` : `https://gps-validation-sic.mavimovil.com`
// };

const conf = {
    api: `${domain}` ,
    apiSettings: process.env.REACT_APP_BASE_URL_SETTINGS,
    cdnLogin:  dev ? 'http://localhost:3001/#/signin' : `${process.env.REACT_APP_BASE_URL_OPERATIONS}/#/signin`,
    cdnWebSocketTransimissionValidator: process.env.REACT_APP_CDN_WEB_SOCKET_TRANSIMISSION_VALIDATOR,
    cdnHistoricalTransimissionValidator: process.env.REACT_APP_CDN_HISTORICAL_TRANSIMISSION_VALIDATOR
};

export const auth = { ...conf.auth };

export const { cdnLogin, api, apiSettings, cdnWebSocketTransimissionValidator, cdnHistoricalTransimissionValidator } = conf;

export const headers = { 'Content-Type': 'application/json' };

export const defaultPage = 1;

export const defaultLimit = 50;

export const limitExport = 1000;

export const userAuthRole = {
    permission: authRole,
    permissionEntities: authEntities,
    login: ['administrator', 'accountant']
};

export const defaultOptionsForm = {
    value: null,
    label: 'home:none'
};

export const defaultEnabledOptionsForm = [
    {
        value: true,
        label: 'devices:enabled',
        checked: true
    },
    {
        value: false,
        label: 'devices:disabled',
        checked: false
    }
];

export const defaultGenderOptionsForm = [
    { ...defaultOptionsForm },
    {
        value: 'male',
        label: 'users:male'
    },
    {
        value: 'female',
        label: 'users:female'
    },
    {
        value: 'other',
        label: 'users:other'
    }
];

export const defaultUsersOptionsFilter = {
    value: null,
    label: 'devices:all_users'
};

export const defaultEnabledOptionsFilter = [
    {
        value: null,
        label: 'devices:all_subStatus'
    },
    ...defaultEnabledOptionsForm
];

export const defaultProfilesOptionsFilter = {
    value: null,
    label: 'profiles:all_profiles'
};

export const defaultStatusOptionsFilter = {
    _id: null,
    value: null,
    label: 'devices:all_status'
};

export const defaultSubstatusOptionsFilter = {
    _id: null,
    value: null,
    label: 'devices:all_subStatus'
};

export const defaultProtocolOptionsForm = [
    {
        value: 'UDP',
        label: 'UDP'
    },
    {
        value: 'TCP',
        label: 'TCP'
    }
];
